export default "__VITE_ASSET__QQNngl1V__"